import { render, staticRenderFns } from "./BaseProgressStepBar.vue?vue&type=template&id=5c6d8b84&scoped=true"
import script from "./BaseProgressStepBar.vue?vue&type=script&lang=js"
export * from "./BaseProgressStepBar.vue?vue&type=script&lang=js"
import style0 from "./BaseProgressStepBar.vue?vue&type=style&index=0&id=5c6d8b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d8b84",
  null
  
)

export default component.exports